import React from 'react';
import { Link } from 'react-router-dom';
import type { AiCaptainPlacedOrder } from '../../utils/aiCaptainTables';
import { useKioskMode } from '../../contexts/KioskModeContext';
import { kioskOrdersPath } from '../../components/Kiosk/kioskPaths';

interface CaptainOrderPlacedCardProps {
  order: AiCaptainPlacedOrder;
  appName: string;
}

const CaptainOrderPlacedCard: React.FC<CaptainOrderPlacedCardProps> = ({ order, appName }) => {
  const { enabled: kioskShell } = useKioskMode();
  const orderHref =
    order.orderId != null
      ? kioskShell
        ? kioskOrdersPath(appName, order.orderId)
        : `/restaurants/${appName}/orders/${order.orderId}`
      : null;
  const label = order.orderCode ? `Order ${order.orderCode}` : order.orderId ? `Order #${order.orderId}` : 'Order placed';
  const prep =
    order.estimatedPrepMinutes != null && order.estimatedPrepMinutes > 0
      ? `Estimated prep: ${order.estimatedPrepMinutes} min`
      : null;

  return (
    <div className="vc-order-card">
      <div className="vc-order-card__icon" aria-hidden>
        <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <path d="M20 6L9 17l-5-5" />
        </svg>
      </div>
      <div className="vc-order-card__body">
        <div className="vc-order-card__title">{label}</div>
        {order.message && <p className="vc-order-card__msg">{order.message}</p>}
        {prep && <p className="vc-order-card__meta">{prep}</p>}
        {orderHref && (
          <Link to={orderHref} className="vc-order-card__link">
            View order
          </Link>
        )}
      </div>
    </div>
  );
};

export default CaptainOrderPlacedCard;
